// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "./assets/build/main." + "cd0460311ff1208dec55" + ".min.css";
};